const c4SiteGeojson = {
  type: "FeatureCollection",
  name: "대륭덕성 지적도_2",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        A0: 131931,
        A1: "1120011500102760002",
        A2: "1120011500",
        A3: "서울특별시 성동구 성수동2가",
        A4: "276-2",
        A5: "276-2대",
        A6: "2023-08-08",
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [127.062841196716846, 37.542294002545276],
              [127.062756661700732, 37.542115667985016],
              [127.062683099671091, 37.541961167929344],
              [127.062552701375864, 37.542000491624648],
              [127.062331633798891, 37.542067279093366],
              [127.062147059389432, 37.542122496698255],
              [127.061977383353394, 37.542173354595704],
              [127.061862901035795, 37.542207930160018],
              [127.061897448915019, 37.54228112712368],
              [127.061954382327883, 37.542401182232958],
              [127.061983648102995, 37.542462786103449],
              [127.062024939537935, 37.542549251187275],
              [127.062046565852242, 37.542594695156282],
              [127.062177836565084, 37.542555173357016],
              [127.062331438362278, 37.542509305939639],
              [127.062601615047029, 37.54242804117105],
              [127.06276320273895, 37.542379529153415],
              [127.062867164489049, 37.542348345913652],
              [127.062841196716846, 37.542294002545276],
            ],
          ],
        ],
      },
    },
  ],
};

export default c4SiteGeojson;
